// Modül 4 - Kritik Hatalar - Ek İçerikler

const cabinCrewContentsM4Extra = {
  // Ünite 3 - Davranış Hataları
  'CM-M4-U3-L1': {
    title: 'Negatif Beden Dili',
    type: 'lesson',
    content: {
      introduction: 'Beden dilinizle yanlış mesajlar göndermenin önüne geçin.',
      sections: [
        {
          title: 'Kapalı Duruş',
          content: 'Çapraz kollar, öne eğik omuzlar, bacak ücste bacak atmak savunmacı ve kapalı bir mesaj verir.'
        },
        {
          title: 'Kaçınılan Göz Teması',
          content: 'Sürekli aşağıya veya başka yere bakmak güvensizlik veya dürüst olmama izlenimi yaratır.'
        },
        {
          title: 'Huzursuz Hareketler',
          content: 'Tırnak yeme, saç oynama, ayak sallama gibi hareketler gerginlik ve hazırlıksızlık gösterir.'
        },
        {
          title: 'Sahte Gülümseme',
          content: 'Gözlere yansımayan, zoraki gülümseme samimiyetsizlik izlenimi verir. Doğal olun.'
        }
      ],
      tips: ['Video kaydı alıp kendinizi izleyin', 'Güvenilir birinden geri bildirim alın', 'Pratiğe devam edin']
    }
  },
  'CM-M4-U3-L2': {
    title: 'Yanlış İletişim',
    type: 'lesson',
    content: {
      introduction: 'Konuşma tarzındaki hatalar ve bunlardan kaçınma yolları.',
      sections: [
        {
          title: 'Aşırı Gurur',
          content: 'Başarıları abartmak, \'en iyi\' olmaktan bahsetmek. Alçakgönüllülük her zaman daha etkileyicidir.'
        },
        {
          title: 'Eski İşvereni Eleştirme',
          content: 'Kesinlikle kaçınılması gereken bir hata. Ne kadar kötü olursa olsun, eski iş hakkında olumsuz konuşmayın.'
        },
        {
          title: 'Klise Cevaplar',
          content: '\'Mükemmeliyetci olduğum için sorun yaşıyorum\' gibi herkesin verdiği cevaplar. Özgün olun.'
        },
        {
          title: 'TMI (Too Much Information)',
          content: 'Çok kişisel detaylar paylaşmak profesyonellik dışıdır. Sınırları koruyun.'
        }
      ],
      tips: ['Sınırlarınızı bilin', 'Profesyonel kalmın', 'Pratik yapın']
    }
  },
  'CM-M4-U3-L3': {
    title: 'Senaryo: Kötü İzlenimler',
    type: 'scenario',
    scenario: {
      title: 'Eski İş Sorusu',
      situation: 'Mülakatçı soruyor: \'Neden önceki işinizden ayrıldınız?\' Gerçek neden: Patronunuzla ciddi sorunlar yaşadınız ve ortam çok toksikti.',
      question: 'Bu soruya nasıl cevap verirsiniz?',
      options: [
        { id: 'a', text: 'Tüm gerçekleri anlatır, patron hakkında şikayetlerimi paylaşırım', correct: false },
        { id: 'b', text: '\'Kariyer gelişimi ve yeni fırsatlar arayışındaydım\' derim', correct: true },
        { id: 'c', text: '\'Zorunlu ayrılık\' derim ve detay vermem', correct: false },
        { id: 'd', text: 'Yalan söyler, hiç çalışmadığımı iddia ederim', correct: false }
      ],
      explanation: 'Olumsuz detaylar paylaşmak profesyonellik dışıdır. Cevabınızı geleceğe odaklayın. \'Gelişim\', \'yeni fırsatlar\' gibi pozitif çerçevelemeler kullanın.'
    }
  },
  'CM-M4-U3-L4': {
    title: '🎮 Hata Bul Quiz',
    type: 'truefalse',
    game: {
      instruction: 'Aşağıdaki davranışların doğru veya yanlış olduğunu belirleyin.',
      statements: [
        { statement: 'Eski işvereni hakkında dürüst olmak için olumsuz şeyler söylemek gerekir', isTrue: false, explanation: 'Dürüstlük önemli ama olumsuzlukları paylaşmak gerekmez' },
        { statement: 'Kolları çapraz bağlamak kapalı bir mesaj verir', isTrue: true, explanation: 'Savunmacı ve kapalı duruş olarak algılanır' },
        { statement: 'Çok gülümsemek samimiyetsiz görünebilir', isTrue: true, explanation: 'Doğal olmayan sürekli gülümseme yapay hissedilir' },
        { statement: 'Başarıları anlatmak güzel bir şeydir', isTrue: true, explanation: 'Evet ama abartmadan ve alçakgönüllükle' },
        { statement: 'Kişisel sorunları paylaşmak empati yaratır', isTrue: false, explanation: 'Profesyonel sınırları korumak gerekir' }
      ]
    }
  },

  // Ünite 4 - Hazırlık Hataları
  'CM-M4-U4-L1': {
    title: 'Araştırma Eksikliği',
    type: 'lesson',
    content: {
      introduction: 'Havayolu hakkında bilgi eksikliği en büyük hatalardan biridir.',
      sections: [
        {
          title: 'Şirket Bilgisi Neden Önemli?',
          content: '\'Neden bu havayolu?\' sorusuna ikna edici cevap veremezseniz, gerçek motivasyonunuz sorgulanır.'
        },
        {
          title: 'Araştırılması Gerekenler',
          content: 'Şirket tarihi, filo bilgileri, destinasyonlar, son haberler, değerler ve misyon, CEO/kurucu bilgileri.'
        },
        {
          title: 'Güncel Haberler',
          content: 'Son bir aydaki şirket haberleri, yeni rotalar, ödüller, sektörel gelişmeler.'
        }
      ],
      tips: ['Şirket web sitesini iyice inceleyin', 'LinkedIn ve sosyal medyayı takip edin', 'Son haberleri okuyun']
    }
  },
  'CM-M4-U4-L2': {
    title: 'Pratik Eksikliği',
    type: 'lesson',
    content: {
      introduction: 'Hazırlıksız mülakata girmek en büyük hatadır.',
      sections: [
        {
          title: 'Cevap Pratikleri',
          content: 'Sık sorulan soruları önceden pratik etmek. Ezber değil, fikirlerinizi organize etmek.'
        },
        {
          title: 'Mock Interview',
          content: 'Arkadaş veya aile ile pratik mülakat yapmak. Video kaydı alıp izlemek.'
        },
        {
          title: 'Grup Pratikleri',
          content: 'Diğer adaylarla grup aktivitesi pratikleri yapmak. Online topluluklar, WhatsApp grupları.'
        }
      ],
      tips: ['Her gün 30 dakika pratik', 'Video kaydı alın', 'Geri bildirim isteyin']
    }
  },
  'CM-M4-U4-L3': {
    title: 'Lojistik Hatalar',
    type: 'lesson',
    content: {
      introduction: 'Mülakat günü lojistik hatalar şansınızı bitirebilir.',
      sections: [
        {
          title: 'Geç Kalma',
          content: 'Affedemez hata. Her zaman en az 30 dakika erken olun. Trafik, park yeri gibi sorunları hesaplayın.'
        },
        {
          title: 'Belge Eksikliği',
          content: 'CV, fotoğraf, diploma, sertifika gibi istenen belgeleri önceden hazırlayın.'
        },
        {
          title: 'Kıyafet Sorunları',
          content: 'Son dakika ütü, eksik düğme, rahat olmayan ayakkabı gibi sorunlar. Bir gün önce her şeyi hazırlayın.'
        },
        {
          title: 'Telefon',
          content: 'Telefonun açık kalması veya çalması. Mutlaka kapatın veya sessizce alın.'
        }
      ],
      tips: ['Bir gün önce her şeyi hazırlayın', 'Yedeği olan olsun', 'Erken gidin']
    }
  },
  'CM-M4-U4-L4': {
    title: '⚡ Hata Yarışı',
    type: 'timerace',
    game: {
      instruction: '45 saniyede kritik hata sorularını cevaplayın!',
      questions: [
        { question: 'Mülakata kaç dakika önce varılmalı?', answer: 'En az 30 dk', options: ['Tam zamanında', 'En az 30 dk', '5 dk', '1 saat'] },
        { question: 'Eski işveren hakkında ne söylenmeli?', answer: 'Nötr/pozitif', options: ['Olumsuz', 'Nötr/pozitif', 'Her şey', 'Hiçbir şey'] },
        { question: 'Şirket araştırması ne için?', answer: 'Motivasyon kanıtlama', options: ['Zaman geçirme', 'Motivasyon kanıtlama', 'Gerekli değil', 'Eğlence'] },
        { question: 'En kritik lojistik hata?', answer: 'Geç kalma', options: ['Yanlış renk takım', 'Geç kalma', 'Farklı ayakkabı', 'Kalem unutma'] },
        { question: 'Mock interview ne?', answer: 'Pratik mülakat', options: ['Gerçek mülakat', 'Pratik mülakat', 'Online sınav', 'Video izleme'] }
      ],
      timeLimit: 45
    }
  },

  // Ünite 5 - Psikolojik Tuzaklar
  'CM-M4-U5-L1': {
    title: 'Aşırı Stres Yönetimi',
    type: 'lesson',
    content: {
      introduction: 'Stres performansınızı ciddi şekilde etkileyebilir.',
      sections: [
        {
          title: 'Stres Belirtileri',
          content: 'Titreme, terleme, ses kısılması, unutkanlık, hızlı konuşma. Bunların farkında olmak ilk adımdır.'
        },
        {
          title: 'Nefes Teknikleri',
          content: 'Derin karın nefesi (4-7-8 tekniği: 4 saniye nefes al, 7 saniye tut, 8 saniye ver). Sakinleştirici etkisi kanıtlanmıştır.'
        },
        {
          title: 'Zihinsel Hazırlık',
          content: 'Pozitif görselleştirme - kendinizi başarılı bir mülakat verirken hayal edin. Güç pozları deneyin.'
        }
      ],
      tips: ['Mülakata girmeden 5 dakika derin nefes', 'Tuvalette güç pozu yapın', 'Kendinize güvenin']
    }
  },
  'CM-M4-U5-L2': {
    title: 'Kararsızlık ve Aşırı Düşünme',
    type: 'lesson',
    content: {
      introduction: 'Fazla düşünmek ve \'mükemmel cevap\' aramak sizi yavaşlatır.',
      sections: [
        {
          title: 'Analysis Paralysis',
          content: 'Cevap verirken fazla düşünmek ve kilitlenmek. \'Doğru\' cevap yerine, doğal cevap verin.'
        },
        {
          title: 'Mükemmeliyetcilik Tuzağı',
          content: 'Her cevabın mükemmel olmasını beklemek. Küçük hatalar normaldir ve tolere edilir.'
        },
        {
          title: 'Çözüm: Hareket',
          content: 'Düşünmek yerine harekete geçin. Cevaba başlayın, giderken düzeltebilirsiniz.'
        }
      ],
      tips: ['5 saniyede cevaba başlayın', 'Hata yapmaktan korkmayın', 'Doğal olun']
    }
  },
  'CM-M4-U5-L3': {
    title: 'Senaryo: Panik Anı',
    type: 'scenario',
    scenario: {
      title: 'Beyaz Sayfa',
      situation: 'Birebir mülakatta panel size beklenmedik bir soru sordu ve aklınız tamamen boşaldı. 10 saniyedir sessiz duruyorsunuz ve panik yapıyorsunuz.',
      question: 'Bu durumu nasıl kurtarabilirsiniz?',
      options: [
        { id: 'a', text: '\'Bu soruyu atlayıp devam edebilir miyiz?\' derim', correct: false },
        { id: 'b', text: '\'Biraz düşünebilir miyim?\' dedikten sonra derin nefes alır ve cevaplarım', correct: true },
        { id: 'c', text: 'Herhangi bir şey söylerim, ne olursa olsun', correct: false },
        { id: 'd', text: 'Ağlamaya başlarım', correct: false }
      ],
      explanation: 'Düşünme zamanı istemek tamamen kabul edilebilir ve profesyonellik gösterir. Derin nefes alın, zamanı kullanın ve sonra cevaplayın.'
    }
  },
  'CM-M4-U5-L4': {
    title: '🎮 Stres Eşleştirme',
    type: 'matching',
    game: {
      instruction: 'Stres belirtisini doğru çözümle eşleştirin.',
      pairs: [
        { left: 'Titreme', right: 'Derin nefes tekniği' },
        { left: 'Akıl boşlaması', right: 'Zaman istemek' },
        { left: 'Hızlı konuşma', right: 'Bilinçli yavaşlama' },
        { left: 'Özgüven eksikliği', right: 'Güç pozları' },
        { left: 'Olumsuz düşünceler', right: 'Pozitif görselleştirme' }
      ],
      timeLimit: 50
    }
  },

  // Ünite 6 - Final Quiz
  'CM-M4-U6-L1': {
    title: '🎓 Modül 4 Final Sınavı',
    type: 'exam',
    exam: {
      title: 'Kritik Hatalar - Final Sınavı',
      passingScore: 70,
      questions: [
        {
          question: 'Çapraz kol bağlamak ne mesaj verir?',
          options: ['Rahatlık', 'Kapalılık ve savunmacılık', 'Özgüven', 'Profesyonellik'],
          correct: 1
        },
        {
          question: 'Eski işveren hakkında ne söylenmeli?',
          options: ['Tüm gerçekler', 'Nötr veya pozitif şeyler', 'Hiçbir şey', 'Yalanlar'],
          correct: 1
        },
        {
          question: 'Mülakata en az kaç dakika önce gidilmeli?',
          options: ['Tam zamanında', '5 dakika', '30 dakika', '2 saat'],
          correct: 2
        },
        {
          question: '4-7-8 nefes tekniğinde kaç saniye tutulur?',
          options: ['4 saniye', '7 saniye', '8 saniye', '10 saniye'],
          correct: 1
        },
        {
          question: 'Analysis paralysis ne demek?',
          options: ['Hızlı karar', 'Aşırı düşünmekten kilitlenme', 'Doğru cevap', 'Panik atak'],
          correct: 1
        },
        {
          question: 'Mock interview nedir?',
          options: ['Gerçek mülakat', 'Pratik mülakat', 'Video izleme', 'Online sınav'],
          correct: 1
        },
        {
          question: 'En kritik hazırlık hatası hangisidir?',
          options: ['Yanlış renk kravat', 'Şirket araştırması yapmamak', 'Kalem unutmak', 'Saç modeli'],
          correct: 1
        },
        {
          question: 'Akıl boşalmasında ne yapılmalı?',
          options: ['Panik yapmak', 'Soruyu atlamak', 'Düşünme zamanı istemek', 'Ağlamak'],
          correct: 2
        }
      ]
    }
  }
};

export default cabinCrewContentsM4Extra;
